import { Navigate, useParams } from "react-router-dom";
import useCapabilities, { useCanViewCommitteesBool } from "@/hooks/useCapabilities";
import { useFlags } from "@/hooks/useFeatureFlags";
import usePageTitle from "@/hooks/usePageTitle";
import AppLayout from "@/layouts/AppLayout";
import { getMembershipServicesNavLinks } from "../../_membershipServicesNavLinks";
import { LEGACY_COMMITTEES_ALL_PATH } from "./constants";
import { useNatlCommitteeManagementGate } from "./useNatlCommitteeManagementEnabled";
import CommitteeDetailPageContent from "./_components/CommitteeDetailPageContent";

export default function NationalCommitteeDetailPage() {
  const { committeeId } = useParams();
  const { loaded } = useCapabilities();
  const { enabled, flagsLoaded } = useNatlCommitteeManagementGate();
  const flags = useFlags();
  const canViewCommittees = useCanViewCommitteesBool();
  const navLinks = getMembershipServicesNavLinks(flags, { canViewCommittees });

  usePageTitle(`/people/membership-services/committees/${committeeId}`, "People | Committee");

  if (!flagsLoaded) {
    return null;
  }

  if (!enabled) {
    return <Navigate to={LEGACY_COMMITTEES_ALL_PATH} replace />;
  }

  if (!canViewCommittees) {
    if (!loaded) {
      return null;
    }
    return <Navigate to="/people/membership-services" replace />;
  }

  if (!committeeId) {
    return null;
  }

  return (
    <AppLayout interior bottomBar navLinks={navLinks}>
      <CommitteeDetailPageContent committeeId={committeeId} committeeScope="national" showCatalogBreadcrumb />
    </AppLayout>
  );
}
